module.exports = __webpack_public_path__ + "static/media/sign.adf5846b.jpg";